import {
  Box,
  Tab,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
  TabIndicator,
} from "@chakra-ui/react";
import React from "react";

const TabTemplate = ({
  tabs = [],
  tabProps,
  tabsProps,
  tabBoxProps,
  tabListProps,
  tabPanelProps,
  customTabPanel,
  tabsPanelsProps,
  tabIndicatorProps,
  showTabIndicator = true,
}: any) => {
  return (
    <Tabs
      position="relative"
      {...tabsProps}
      css={{
        "*::-webkit-scrollbar": {
          display: "none",
        },
        "*::-webkit-scrollbar-thumb": {
          display: "none",
        },
      }}
    >
      <Box position="sticky" top="56px" zIndex="9" {...tabBoxProps}>
        <TabList
          borderBottom="1px solid"
          borderColor="#B3B3B3"
          {...tabListProps}
        >
          {tabs?.length > 0 &&
            tabs?.map((tab:any, index:number) => (
              <Tab
                key={index}
                color="#6C6768"
                textStyle="body2-md"
                _focus={{ boxShadow: "none" }}
                _selected={{
                  background: "#F2F6FF !important",
                  color: "#3470E4",
                }}
                _focusVisible={{
                  boxShadow: "0 0 0 3px rgba(66, 153, 225, 0.6)",
                }}
                {...tabProps}
              >
                {tab?.text}
              </Tab>
            ))}
          {showTabIndicator && (
            <TabIndicator
              height="2px"
              bg="blue.500"
              bottom="0px"
              {...tabIndicatorProps}
            />
          )}
        </TabList>
      </Box>
      <TabPanels {...tabsPanelsProps}>
        {tabs?.length > 0 &&
          tabs?.map((tabPanel: any, index: number) => (
            <TabPanel key={index} {...tabPanelProps}>
              {customTabPanel ? customTabPanel(tabPanel) : tabPanel?.data}
            </TabPanel>
          ))}
      </TabPanels>
    </Tabs>
  );
};

export default TabTemplate;
